import React, { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import { HStack, theme, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationIngredientsGridSectionStack = (props: Props) => {
  const { children, gap } = props;

  const { match } = useResponsive();

  return (
    <HStack
      gap={gap ?? match([theme.spacing['2'], theme.spacing['4']])}
      style={match([styles.rowGapXS, styles.rowGapSM])}
      itemsPerRow={match([3, 2, 4, 5])}
    >
      {children}
    </HStack>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  rowGapXS: {
    rowGap: theme.spacing['4'],
  },
  rowGapSM: {
    rowGap: theme.spacing['6'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  gap?: number;
}>;
